import { render, staticRenderFns } from "./dimsetup.vue?vue&type=template&id=6be4fef2"
import script from "./dimsetup.vue?vue&type=script&lang=js"
export * from "./dimsetup.vue?vue&type=script&lang=js"
import style0 from "./dimsetup.vue?vue&type=style&index=0&id=6be4fef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports